import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import DataTableComponent from "../../components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteReportGroupData,
  fetchReportsListingData,
} from "../../redux/slice/ReportsListingSlice";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import "./Reports.css";
import {
  deleteReportListData,
  fetchReportsListData,
} from "../../redux/slice/ReportsSlice";
import { useNavigate } from "react-router-dom";
import DeleteConFirmationModal from "../../components/Common/DeleteConFirmationModal";
import { CiEdit } from "react-icons/ci";
import TrashIcon from "../../Assets/svg/trash-icon.svg";
import { usePic } from "../../context/PicProvider";
import { RxTriangleDown } from "react-icons/rx";

function Reports() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [removeId, setRemoveId] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [showDropCon, setShowDropCon] = useState(false);
  const [downDrop, setDownDrop] = useState(false);
  const [deleteEventHandler, setDeleteEventHandler] = useState(() => () => {});
  const [cancelEventHandler, setCancelEventHandler] = useState(() => {});
  const { setIsLoading } = usePic();

  const { status, data: ReportsManagementData } = useSelector(
    (state) => state.REPORTSLISTING
  );

  const { fetchReportListingData } = useSelector(
    (state) => state.REPORTSLISTINGDATA
  );

  useEffect(() => {
    dispatch(fetchReportsListingData());
    dispatch(fetchReportsListData());
  }, [dispatch]);

  const handleCloseDeleteReport = () => {
    setDeleteConfirm(false);
    setModalConfirmTitle("");
    setDeleteEventHandler(() => () => {});
    setDownDrop(false);
    setShowDropCon(false);
    setRemoveId([]);
  };

  const removeReportHandler = async () => {
    setIsLoading(true);
    const res = await dispatch(deleteReportListData({ reportIds: removeId }));
    setIsLoading(false);
    if (res?.payload?.status === 200) {
      handleCloseDeleteReport();
      dispatch(fetchReportsListData());
    }
  };

  const deleteHandlerReport = () => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this report?");
    setCancelEventHandler(() => handleCloseDeleteReport);
    setDeleteEventHandler(() => () => removeReportHandler(removeId));
  };

  const handleCloseDeleteGroup = () => {
    setDeleteConfirm(false);
    setModalConfirmTitle("");
    setDeleteEventHandler(() => () => {});
  };

  const deleteReportGroupHandler = async (deleteId) => {
    // Set the loader state to 'loading'
    setIsLoading(true);
    const res = await dispatch(deleteReportGroupData(deleteId));
    setIsLoading(false);
    if (res?.payload?.status === 200) {
      handleCloseDeleteGroup();
      dispatch(fetchReportsListingData());
    }
  };

  const removeReportGroupHandler = (id) => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this report group?");
    setDeleteEventHandler(() => () => deleteReportGroupHandler(id));
    setCancelEventHandler(() => handleCloseDeleteGroup);
  };

  const onSelectedCheckboxChange = (check) => {
    const selectedId = check?.selectedRows.map((curElm) => curElm._id);
    if (selectedId.length > 0) {
      setRemoveId(selectedId);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };

  const clickRowHandler = (row) => {
    navigate(`/edit_report_listing/${row._id}`);
  };

  function formatFrequency(unit) {
    const frequencyMap = {
      daily: "1 X Daily",
      weekly: "1 X Weekly",
      bi_weekly: "2 X Month",
      monthly: "1 X Monthly",
      quarterly: "1 X Quarter",
      semi_annually: "2 X Annual",
      annually: "1 X Annually",
    };

    return frequencyMap[unit] || unit;
  }

  const getRecipientsCount = (data) => {
    return (
      (data?.send_to_user?.length ?? 0) + (data?.send_to_group?.length ?? 0)
    );
  };

  const reportsColumns = [
    {
      name: "Report Name",
      selector: (row) => row.report_name,
    },
    {
      name: "Frequency",
      selector: (row) => `${formatFrequency(row?.frequency_units)}`,
    },
    {
      name: "Recipients",
      selector: (row) => getRecipientsCount(row),
    },
    {
      name: "Last Sent",
      selector: (row) => {
        const date = new Date(row.start_on);
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return `${day} ${months[monthIndex]} ${year}`;
      },
      sortable: true,
    },
  ];

  const downIconHandler = () => {
    setDownDrop(!downDrop);
  };

  const editReportGroup = (groupId) => {
    navigate(`/edit_report_group/${groupId}`);
  };

  const userData = fetchReportListingData || [];
  if (status === "loading") {
    return <Loader />;
  }

  return (
    <>
      <div className="d-flex flex-grow-1 position-relative">
        <Row className="flex-grow-1 position-absolute w-100 h-100 row-gap-3">
          <Col md={7} xl={7.5} xxl={8.5} className="h-100">
            <div
              className="content_block-padding h-100 bg-white"
              style={{ borderRadius: "16px" }}
            >
              <DataTableComponent
                search={false}
                searchBy={["report_name", "frequency_units", "how_often"]}
                columns={reportsColumns}
                data={userData}
                title="Reports"
                selectedRows
                clickedRow={clickRowHandler}
                checkboxChange={onSelectedCheckboxChange}
              />
              {userData && userData.length > 0 && showDropCon && (
                <div className="dropdown_icon_style">
                  <div onClick={() => downIconHandler()}>
                    <RxTriangleDown size={23} />
                  </div>
                  {downDrop && (
                    <Button
                      variant="link"
                      disabled={removeId.length === 0 ? true : false}
                      onClick={() => deleteHandlerReport()}
                    >
                      <div className="event-box-data-user-event-listing">
                        <h6 className="cursor">Delete</h6>
                        {/* <h6 className="cursor mt-1" onClick={() => statusHandler()}>
                Disable/Enable{" "}
              </h6> */}
                      </div>
                    </Button>
                  )}
                </div>
              )}
            </div>
          </Col>
          <Col
            md={5}
            xl={4.5}
            xxl={3.5}
            className="overflow-y-auto"
            style={{ maxHeight: "100%" }}
          >
            <Card style={{ border: "none" }} className="h-100">
              <div
                className="p-3 position-sticky top-0 bg-white"
                style={{
                  borderTopRightRadius: "10px",
                  borderTopLeftRadius: "10px",
                }}
              >
                <h4 className="listing text-center m-0 fw-bold">
                  Report Groups
                </h4>
                <hr className="mt-4 mb-1" />
              </div>

              {status === "loading" && <p>Loading...</p>}
              {status === "error" && <p>Error fetching data.</p>}
              {status === "idle" &&
              Array.isArray(ReportsManagementData) &&
              ReportsManagementData.length > 0 ? (
                <div>
                  {ReportsManagementData?.map((group) => (
                    <div
                      className="title-box mb-2"
                      key={group._id}
                      style={{ borderRadius: 10 }}
                    >
                      <div className="d-flex justify-content-between px-3 pb-2">
                        <p className="mb-0">{group.group_name}</p>
                      </div>
                      <div className="person-box">
                        <b>Directors</b>
                        <p className="mt-2 mb-2 border-top border-bottom py-2">
                          {group.group_member?.map((member) => (
                            <span key={member._id}>{member.full_name}, </span>
                          ))}
                        </p>
                        <div className="d-flex gap-3 flex-wrap align-items-center justify-content-evenly">
                          <Button
                            variant="link"
                            onClick={() => editReportGroup(group._id)}
                          >
                            <span className="d-flex align-items-center gap-2 text_gray pointer">
                              <CiEdit size={30} /> Edit
                            </span>
                          </Button>
                          <Button
                            variant="link"
                            onClick={() => removeReportGroupHandler(group._id)}
                          >
                            <span className="d-flex align-items-center gap-2 text_gray">
                              <img src={TrashIcon} alt="trash-icon" />
                              Delete
                            </span>
                          </Button>
                          {/* <button
                          onClick={() => deleteReportGroupHandler(group._id)}
                          className="btn-delete btn btn-danger px-4 py-2 ms-2"
                        >
                          Delete
                        </button> */}
                        </div>
                      </div>
                      <p className="mt-3 px-3">Sales Reps</p>
                    </div>
                  ))}
                </div>
              ) : (
                <h6 className="fw-bold text-center fw-bold mb-0">
                  No report groups found
                </h6>
              )}
            </Card>
          </Col>
        </Row>
      </div>
      {deleteConfirm && (
        <DeleteConFirmationModal
          show={deleteConfirm}
          title={modalConfirmTitle}
          eventHandler={deleteEventHandler} // For individual reports
          hide={cancelEventHandler}
        />
      )}
    </>
  );
}

export default Reports;
